import { Edit, SimpleForm, useNotify, useStore } from "react-admin";

import CyclicExamForm from "./CyclicExamForm";
import { CYCLIC_STORE_KEY } from "./List";

import { errorMessages } from "app";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";

import { handleTransform } from "./Create";

import CyclicExamFormTopToolbar from "./CyclicExamFormTopToolbar";

const EditCyclicExams = () => {
  const [filters] = useStore(CYCLIC_STORE_KEY);

  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();

  return (
    <>
      <CyclicExamFormTopToolbar cyclicStreamId={filters.cyclicStreamId} />
      <Edit
        transform={handleTransform(filters)}
        mutationMode="pessimistic"
        title=" Редакция на цикличен изпит"
        onError={e => {
          const errorMessage = e.message || errorMessages[e.errorCode];
          notify(errorMessage, { type: "error" });
          handleConflictError(e);
        }}
      >
        <SimpleForm>
          <CyclicExamForm
            filters={filters}
            mode="edit"
          />
        </SimpleForm>
      </Edit>

      <ConflictErrorDialog />
    </>
  );
};
export default EditCyclicExams;
